export const initialState = {
  availableRecipes: {
    recipes: [],
    total: 0
  },
  isLoading: false,
  error: null,
};
